<template>
    <svg :width="160" :height="32" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <transition v-if="showLogo" name="fade">
                <g fill="none" fill-rule="evenodd">
                    <g transform="translate(38.757 14.338)">
                        <mask fill="#fff">
                            <use xlink:href="#a"/>
                        </mask>
                        <path fill="#000"
                              d="M116.432 8.83c0-1.612-1.183-2.812-2.797-2.812-1.613 0-2.8 1.204-2.8 2.812 0 1.61 1.187 2.813 2.8 2.813 1.614 0 2.797-1.2 2.797-2.813Zm-2.57-5.421c3.094 0 5.381 2.311 5.381 5.422 0 3.106-2.287 5.437-5.381 5.437a4.925 4.925 0 0 1-2.826-.864v4.258h-2.777V3.699h1.836l.475.933c.872-.772 2.01-1.223 3.292-1.223ZM103.95 8.83c0-1.662-1.136-2.813-2.738-2.813-1.6 0-2.737 1.15-2.737 2.813 0 1.662 1.136 2.813 2.737 2.813 1.602 0 2.738-1.151 2.738-2.813Zm-8.29 0c0-3.114 2.37-5.422 5.552-5.422 3.167 0 5.553 2.312 5.553 5.422 0 3.094-2.386 5.421-5.553 5.421-3.182 0-5.552-2.327-5.552-5.421Zm-3.752 0c0-1.662-1.136-2.813-2.737-2.813-1.602 0-2.738 1.15-2.738 2.813 0 1.662 1.136 2.813 2.738 2.813 1.601 0 2.737-1.151 2.737-2.813Zm-8.29 0c0-3.114 2.37-5.422 5.553-5.422 3.166 0 5.553 2.312 5.553 5.422 0 3.094-2.387 5.421-5.553 5.421-3.182 0-5.553-2.327-5.553-5.421Zm-3.13 5.131-3.287-4.91v4.91h-2.777V0h2.777v8.26l3.084-4.56h3.199L80.01 8.586l3.845 5.375H80.49Zm-7.97-6.22v6.22h-2.777v-5.77c0-1.552-.59-2.3-1.792-2.3-1.432 0-2.305 1.024-2.305 2.676v5.394h-2.777V3.7h1.905l.542 1.269c.777-.925 2.005-1.512 3.403-1.512 2.342 0 3.8 1.687 3.8 4.286ZM58.164 8.815c0-1.612-1.183-2.812-2.796-2.812-1.614 0-2.8 1.204-2.8 2.812 0 1.609 1.186 2.813 2.8 2.813 1.613 0 2.796-1.2 2.796-2.813Zm2.722-5.131v10.263H58.71l-.239-.918c-.882.771-2.033 1.224-3.329 1.224-3.09 0-5.388-2.331-5.388-5.438 0-3.094 2.298-5.406 5.388-5.406 1.319 0 2.487.464 3.375 1.255l.297-.98h2.073ZM45.42 8.815c0-1.612-1.183-2.812-2.797-2.812-1.613 0-2.8 1.204-2.8 2.812 0 1.609 1.187 2.813 2.8 2.813 1.614 0 2.797-1.2 2.797-2.813Zm2.722-5.131v10.263h-2.178l-.238-.918c-.882.771-2.033 1.224-3.329 1.224-3.09 0-5.389-2.331-5.389-5.438 0-3.094 2.299-5.406 5.389-5.406 1.318 0 2.487.464 3.375 1.255l.296-.98h2.074Zm-11.88 7.808v2.47h-1.973c-2.26 0-3.648-1.387-3.648-3.664V5.93h-1.858v-.6l4.057-4.309h.531v2.678h2.835v2.23h-2.788v4c0 .992.57 1.563 1.582 1.563h1.263Zm-12.146 2.76c-2.579 0-4.301-1.47-4.315-3.67h2.708c.014.914.714 1.37 1.71 1.37.772 0 1.462-.349 1.462-1.034 0-.702-.891-.914-1.977-1.096-1.641-.273-3.728-.712-3.728-3.13 0-1.943 1.653-3.283 4.132-3.283 2.48 0 4.108 1.378 4.118 3.43H25.59c-.011-.816-.583-1.219-1.552-1.219-.864 0-1.375.396-1.375.984 0 .684.877.843 1.944 1.036 1.676.3 3.815.655 3.815 3.155 0 2.094-1.714 3.457-4.308 3.457Zm-13-6.54h4.979c-.393-1.254-1.295-1.934-2.541-1.934-1.237 0-2.115.72-2.437 1.935Zm7.756 1.083c0 .27-.02.542-.054.813h-7.774c.24 1.4 1.163 2.172 2.51 2.172.965 0 1.757-.456 2.179-1.19h2.919c-.747 2.237-2.713 3.662-5.098 3.662-3.033 0-5.328-2.346-5.328-5.421 0-3.091 2.28-5.422 5.328-5.422 3.154 0 5.318 2.43 5.318 5.386ZM7.479 11.492v2.47H5.506c-2.26 0-3.649-1.387-3.649-3.664V5.93H0v-.6l4.057-4.309h.53v2.678h2.835v2.23H4.635v4c0 .992.57 1.563 1.582 1.563h1.262Z"
                              />
                    </g>
                </g>
            </transition>
            <path d="M32.517 16c0 8.836-7.28 16-16.259 16C7.278 32 0 24.836 0 16h32.517Z" fill="#BE006E"/>
            <path d="M32.517 16c0-8.837-7.28-16-16.259-16C7.278 0 0 7.163 0 16h32.517Z" fill="#FA5528"/>
        </g>
    </svg>

</template>

<script>
export default {
    props: ['width'],
    data() {
        return {
            scrolled: false,
            showLogo: false,
            logoTimeout: null,
            isInitialLoad: true
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll(); // initialize on mount
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.logoTimeout) clearTimeout(this.logoTimeout);
    },
    methods: {
        handleScroll() {
            if (window.scrollY === 0) {
                if (this.isInitialLoad) {
                    // On initial load, show logo immediately
                    this.showLogo = true;
                    this.isInitialLoad = false;
                } else if (!this.showLogo && !this.logoTimeout) {
                    // On subsequent scrolls to top, apply delay
                    this.logoTimeout = setTimeout(() => {
                        this.showLogo = true;
                        this.logoTimeout = null;
                    }, 100);
                }
            } else {
                if (this.logoTimeout) {
                    clearTimeout(this.logoTimeout);
                    this.logoTimeout = null;
                }
                this.showLogo = false;
                this.isInitialLoad = false; // Ensure isInitialLoad is false after scrolling
            }
            this.scrolled = window.scrollY > 0;
        }
    }
}
</script>

<style scoped>
/* Fade transition for logos */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
